function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 57,
  rx: 28,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9563 37.7386C31.8768 37.7386 34.6808 35.5824 34.6722 32.5994C34.6808 30.4261 33.3001 28.875 30.7347 28.5511V28.4148C32.6864 28.0653 34.033 26.6847 34.0245 24.7244C34.033 21.9716 31.6211 19.8068 28.0075 19.8068C24.4279 19.8068 21.7347 21.9034 21.6836 24.9205H25.2205C25.2631 23.5909 26.4819 22.7301 27.9904 22.7301C29.4819 22.7301 30.479 23.6335 30.4705 24.946C30.479 26.3182 29.3114 27.2472 27.6325 27.2472H26.0046V29.9574H27.6325C29.6097 29.9574 30.8455 30.946 30.837 32.3523C30.8455 33.7415 29.6523 34.696 27.9648 34.696C26.337 34.696 25.1183 33.8438 25.0501 32.5653H21.3342C21.3938 35.6165 24.1211 37.7386 27.9563 37.7386Z",
  fill: "white"
});

function SvgBulletIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletIcon3);
export default __webpack_public_path__ + "static/media/bulletIcon3.7bf722f7.svg";
export { ForwardRef as ReactComponent };